module.exports = __webpack_public_path__ + "img/badge_3.png";